/**
 * Application id sent on login (`app_name`). Value comes from webpack
 * `DefinePlugin` / `APP_NAME` env at build time (see `webpack.config.js`).
 */
export const APP_NAME: string = __WEBPACK_APP_NAME__;
